import { z } from "zod";

// Report bug schema.
export const reportBugSchema = z.object({
  title: z.string().min(1, "Title is required"),
  description: z.string().min(1, "Description is required"),
  includeScreenshot: z.boolean(),
  allowAdminAccess: z.boolean(),
});

export type ReportBugType = z.infer<typeof reportBugSchema>;
